import React from 'react';
import styles from './index.module.scss';
import Link from 'gatsby-link';
import LOGO_IMAGE from 'img/logo.png';


export default function Logo() {
    return <div>
        <Link to="/" className={styles.logo}>
            <img src={LOGO_IMAGE} alt="" className={styles.image} />
            {' '}
            <span className={styles.brandName}>
                <span className={styles.brandReinvent}>Reinvent</span>
                {' '}<span className={styles.brandSoftware}>Software</span>
            </span>
        </Link>
    </div>;
}



// WEBPACK FOOTER //
// ./src/components/logo/index.js